import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { transientOptions } from "@product/scmp-sdk";

import CheckboxTick from "./checkbox-tick.svg";

type CheckboxProps = {
  $checked?: boolean;
};
export const Checkbox = styled(CheckboxTick, { ...transientOptions })<CheckboxProps>`
  inline-size: 24px;
  block-size: 24px;

  line-height: 22px;
  text-align: center;

  border: 1px solid #979797;
  border-radius: 2px;

  background-color: #ffffff;

  cursor: pointer;
  ${props =>
    props.$checked &&
    css`
      border-color: #4585ff;

      background: #4585ff;
    `}
`;
